const useResourceRoleDisplayText = ({
  isPsaRmpMultipleRolesMilestone1Enabled,
  resourceEstimate
}) => {
  if (!isPsaRmpMultipleRolesMilestone1Enabled) {
    return resourceEstimate?.projectRole?.displayText;
  }

  const { defaultRole, totalRoleCount } =
    resourceEstimate?.taskResourceUserRoleAssignmentSummary ?? {};
  const baseRoleText = defaultRole?.displayText;

  return baseRoleText && totalRoleCount > 1
    ? `${baseRoleText} + ${totalRoleCount - 1}`
    : baseRoleText;
};

export default useResourceRoleDisplayText;
